import React from 'react'

import Stack from '@mui/material/Stack'

import { MerchantLogo, P, Text } from '@mxenabled/mxui'

import { type Transaction, TransactionType } from '../../../../core'
import { formatCurrency } from '../../../../core/utils/NumberFormatting'

interface TransactionAmountHeaderProps {
  transaction: Transaction
}

const TransactionAmountHeader: React.FC<TransactionAmountHeaderProps> = ({ transaction }) => {
  const { amount, description, merchant_guid, payee, top_level_category_guid, transaction_type } =
    transaction

  const isCredit = transaction_type === TransactionType.CREDIT

  return (
    <Stack className="mx-txn-amount-header" direction="row" gap={12} px={16} py={24}>
      <MerchantLogo
        categoryGuid={top_level_category_guid || ''}
        merchantGuid={merchant_guid || ''}
        size={64}
      />
      <Stack overflow="hidden">
        <Text bold={true} mb={4} truncate={true} variant="body1">
          {description || payee}
        </Text>
        <P color={isCredit ? 'success.main' : 'text.primary'} truncate={true} variant="h1">
          {isCredit ? '+' : ''}
          {formatCurrency(amount, '0,0.00')}
        </P>
      </Stack>
    </Stack>
  )
}

export default TransactionAmountHeader
